import React, { Component } from 'react';
import { Table, Modal, Button, Icon, DatePicker, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

const { MonthPicker } = DatePicker;
const monthFormat = 'YYYY-MM';
class RateHistory extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
        monthDate:moment().subtract(1, 'M'),
        maxDate:moment().subtract(1, 'M'),
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    loadData = () => {
        this.setState({ loading: true });
        const { monthDate } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.contract.queryCurrencyExchangeRateList,
            data: { 
                offset: 1,
                limit: 999,
                endEffectDate:monthDate.format(monthFormat),
                startEffectDate:monthDate.format(monthFormat),
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [], totalCount } = res;
                let originalCurrency = '',endData = {},effectDate = '',newdata = [];
                // pagination.total = totalCount;
                datas.forEach((element ,index) => {
                    if(element.dateType == 'MonthStart'){
                        originalCurrency = element.originalCurrency;
                        effectDate = element.effectDate.slice(0,7);
                        endData = datas.find((item , index) =>{
                            return (item.originalCurrency == originalCurrency && item.dateType == 'MonthEnd' && item.effectDate.slice(0,7) == effectDate)
                        })
                        element.monthStart = element.rate;
                        element.monthEnd = endData?endData.rate:'';
                        newdata.push(element)
                    }
                });
                // pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: newdata,
                });
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => ([
        {
            title: '生效日期',
            dataIndex: 'effectDate',
            key: 'effectDate',
            render:text => text ? text.slice(0, 7) : '',
            // //width: 100,
        }, {
            title: '币种',
            dataIndex: 'originalCurrencyName',
            key: 'originalCurrencyName',
            //width: 160,
        }, {
            title: '币种代码',
            dataIndex: 'originalCurrency',
            key: 'originalCurrency',
            //width: 100,
        },{
            title: '月初汇率',
            dataIndex: 'monthStart',
            key: 'MonthStart',
            //width: 160,
        },{
            title: '月末汇率',
            dataIndex: 'monthEnd',
            key: 'MonthEnd',
            //width: 160,
        } 
    ])

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data?data.map(item => ({ ...item } )):data;
        return dataSource;
    }
    prevMonth = () => {
        const { monthDate } = this.state;
        this.setState({ monthDate: monthDate.subtract(1, 'M') }, () => {
            this.loadData();
        });
    }

    handleDateChange = (date, dateString) => {
        this.setState({ monthDate: date }, () => {
            this.loadData();
        });
    }
    nextMonth = () => {
        const { monthDate, maxDate } = this.state;
        const newMonthDate = moment(monthDate).add(1, 'M');
        if (newMonthDate.valueOf() > moment(maxDate).valueOf()) {
            message.warning('不能大于该月份！');
            return;
        }
        this.setState({ monthDate: newMonthDate }, () => {
            this.loadData();
        });
    }
    disabledDate = (current) => {
        const { maxDate } = this.state;
        const value = moment(maxDate).valueOf();
        return current && current.valueOf() > value;
    }

    render() {
        const { visible, loading, monthDate = null  } = this.state;
        return (
            <Modal
                title="币种汇率存档历史"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="660px"
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div className="monthSelect">
                        <Icon type="left-circle-o" style={{ color: '#5850C9' }} onClick={this.prevMonth} />
                        <MonthPicker allowClear={false} value={monthDate} format={monthFormat} onChange={this.handleDateChange} disabledDate={this.disabledDate} />
                        <Icon type="right-circle-o" style={{ color: '#5850C9' }} onClick={this.nextMonth} />
                    </div>
                    <div>
                        <Table
                            bordered
                            loading={loading}
                            pagination={false}
                            //scroll={{x: 600, y: 270}}
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            rowKey={record => record.jdeApplyApprovalHistoryId}
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

export { RateHistory };



// WEBPACK FOOTER //
// ./src/components/contractManagement/currencyExchangeRate/RateHistory.js